import SubscriptionActivateModal from './SubscriptionActivateModal';

export default SubscriptionActivateModal;
